"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFileUploadHelperText = exports.StyledFileUploaddWrapper = exports.StyledFileUploadInput = exports.StyledFileUploadName = exports.StyledFileUploadButton = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const flexbox_1 = require("../flexbox");
const typography_1 = require("../typography");
exports.StyledFileUploadButton = (0, styled_components_1.default)(typography_1.Typography) `
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 4px;
  padding: 4px;
  line-height: unset;
`;
exports.StyledFileUploadName = (0, styled_components_1.default)(typography_1.Typography) `
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
exports.StyledFileUploadInput = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  ${({ error, disabled = false }) => (0, styled_components_1.css) `
    background-color: ${theme_1.grayScale[200]};
    height: ${theme_1.spacings.s9};
    padding: 0 ${theme_1.spacings.s4};
    border-bottom: 2px solid ${error ? theme_1.system.error : 'transparent'};
    color: white;
    cursor: pointer;

    &:hover {
      ${exports.StyledFileUploadButton} {
        color: ${theme_1.primary.dark};
      }
    }

    ${disabled &&
    (0, styled_components_1.css) `
      background-color: ${theme_1.grayScale[100]};
      cursor: not-allowed;
      user-select: none;
      pointer-events: none;
      border-bottom: 0;
      ${exports.StyledFileUploadButton}, ${exports.StyledFileUploadName} {
        color: ${theme_1.grayScale[400]};
      }

      &:hover {
        ${exports.StyledFileUploadButton} {
          color: ${theme_1.grayScale[400]};
        }
      }
    `}
  `}
`;
exports.StyledFileUploaddWrapper = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  max-height: 100px;
  height: auto;
  position: relative;
  padding: 5px;

  &:focus-within,
  &:focus,
  &:focus-visible {
    ${exports.StyledFileUploadButton} {
      box-shadow: ${theme_1.shadows.containedFocus(theme_1.primary.dark, theme_1.primary.dark)};
    }
  }
`;
exports.StyledFileUploadHelperText = (0, styled_components_1.default)(flexbox_1.Flexbox) `
  margin-top: ${theme_1.spacings.s3};
  color: ${theme_1.system.error};
`;
//# sourceMappingURL=styles.js.map